import {  Component,  OnInit, Injectable } from '@angular/core';
import {  trigger,  style,  animate,  transition,  state } from '@angular/animations';
import {  Router, Resolve, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';

//Models
import {  User } from '../../shared/models/user.model';
import { UserStates } from '../..//shared/models/userstate.model';
import { UserRoles } from '../../shared/models/roles.model';
//Servicios
import {  UserService } from '../../shared/_services/user.service';
import {  UtilitiesService } from '../../shared/_services/utilities.service';

//Mockups
//import { ESTADOS } from '../../shared/mockups/estados.mockup';
//import { USUARIOS } from '../../shared/mockups/users.mockup';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.css'],
  animations: [
    trigger('EnterLeave', [
      state('flyin', style({
        opacity: 1,
        transform: 'translateX(0%)'
      })),
      transition(':enter', [
        style({
          opacity: 0.2,
          transform: 'translateX(-100%)',     
        }),
        animate('0.3s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          transform: 'translateX(100%)'       
        }))
      ])
    ])
  ]
})

export class AdminUsersComponent implements OnInit {

  ListUsuarios: User[];
  ListEstados: UserStates[];
  //ListRoles: UserRoles[];

  SearchTerm: string;

  isNewUser: boolean = false;
  //  isExpandido: boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _ultilitesService: UtilitiesService
  ) { }

  ngOnInit() { 
    this.ListUsuarios = this.route.snapshot.data['adminUserData'].filter(x => x.fkUserRole != 1) as User[];
    this.ListEstados = this._ultilitesService.currentListUserstates;
    this.SearchTerm = "0";
  }

  onKeyUp(buscar) {
    this.SearchTerm = buscar;
  }

  toggleNewUser() {
    //this.router.navigate(['/admin-users'])
    this.isNewUser = !this.isNewUser;
  }

  collapse(variable:boolean) {
    this.isNewUser = variable;
  }

  onAddUser(event: User) {    
    this.ListUsuarios.push(event);
    this.isNewUser = false;
  }

}


@Injectable()
export class AdminUserResolve implements Resolve<any> {

  constructor(
    private _userService: UserService,
    private _ultilitesService: UtilitiesService
  ) {}

  resolve() {
    //Carga la lista de Estados de Usuario
    this._ultilitesService.getAllUserStates();
    //Carga la lista de Roles de Usuario
    this._ultilitesService.getAllRoles();
    // Carga y Retirna la lista de Usuarios
    return this._userService.getAll();
  }

}
